import styles from "./IntroTest.module.less";
import { useState, useEffect, useRef } from "react";
import CommonNavBar from "views/components/CommonNavBar";
import { useNavigate, useSearchParams } from "react-router-dom";
import BottomSheet from "./BottomSheet";
import { demoAnswerV2, submitAnswerV3, spokenSubmitAnswer } from "api/mine";
import { Toast } from "react-vant";
import CryptoJS from "crypto-js";
import wx from "weixin-js-sdk";

const IntroTest = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [step, setStep] = useState(0);
  const [sheetVisible, setSheetVisible] = useState(false);
  const [pages, setPages] = useState([]);
  const [postForm, setPostForm] = useState([]);
  const [showNav, setShowNav] = useState(false);
  const inputRef = useRef(null);
  const toastRef = useRef(null);
  const wxTokenRef = useRef(null);
  const stepTimerRef = useRef(null); // 存储延迟跳转的定时器ID
  const isHandlingBackRef = useRef(false); // 防止重复点击

  const parseFraction = (str) => {
    // 移除空格
    str = str.trim();

    // 检查是否包含斜杠
    if (!str.includes("/")) {
      return parseFloat(str);
    }

    // 分割分子和分母
    const parts = str.split("/");
    if (parts.length !== 2) {
      return NaN;
    }

    const numerator = parseFloat(parts[0].trim());
    const denominator = parseFloat(parts[1].trim());

    // 检查是否为有效数字且分母不为0
    if (isNaN(numerator) || isNaN(denominator) || denominator === 0) {
      return NaN;
    }

    return numerator / denominator;
  };

  const renderStep = () => {
    switch (pages[step].type) {
      case "填空题":
        let defaultName = "";
        try {
          if (params.get("isWx") === "true") {
            defaultName = params.get("english_name") || "";
          } else {
            defaultName = JSON.parse(
              localStorage.getItem("userInfo")
            ).english_name;
          }
        } catch (error) {
          defaultName = "";
        }
        return (
          <div className={styles["step-1"]}>
            <div className={styles["step-1-title"]}>{pages[step].title}</div>
            <input
              ref={inputRef}
              key={`input-${step}`}
              className={styles["step-1-input"]}
              placeholder={pages[step].title}
              defaultValue={defaultName}
              maxLength={15}
              onInput={(e) => {
                const value = e.target.value;
                const englishOnly = value.replace(/[^a-zA-Z]/g, "");
                const limitedValue = englishOnly.slice(0, 15);
                e.target.value = limitedValue;
              }}
            />
            <img
              className={styles["step-1-button"]}
              src={require("@/images/picture/intro-test/start-phone.png")}
              onClick={() => {
                const inputValue = inputRef.current?.value?.trim();
                if (inputValue) {
                  setPostForm((prev) => [
                    ...prev,
                    {
                      page: pages[step].page,
                      title: pages[step].title,
                      selected_option: inputValue,
                      level_range: [],
                    },
                  ]);
                  setStep(pages[step].next_page - 1);
                } else {
                  Toast.info(pages[step].title);
                }
              }}
            />
          </div>
        );
      case "下拉选择框":
        const sheetOptions = pages[step]?.options?.map((item) => {
          return {
            text: item.text,
            value: item.text,
          };
        });
        return (
          <div className={styles["step-2"]}>
            <div className={styles["step-2-title"]}>{pages[step].title}</div>
            <input
              key={`input-${step}`}
              className={styles["step-2-input"]}
              placeholder={pages[step].title}
              value={
                postForm.find((item) => item.page === pages[step].page)
                  ?.selected_option ?? ""
              }
              readOnly
              onClick={() => {
                if (postForm.find((item) => item.page === pages[step].page)) {
                  return;
                }
                setSheetVisible(true);
              }}
            />
            <BottomSheet
              visible={sheetVisible}
              onClose={() => setSheetVisible(false)}
              maskClosable={true}
              options={sheetOptions}
              onConfirm={(value) => {
                if (value !== null) {
                  setSheetVisible(false);
                  setPostForm((prev) => [
                    ...prev,
                    {
                      page: pages[step].page,
                      title: pages[step].title,
                      selected_option: value,
                      level_range:
                        pages[step]?.options?.find(
                          (item) => item.text === value
                        )?.level || [],
                    },
                  ]);
                  // 清除之前的定时器
                  if (stepTimerRef.current) {
                    clearTimeout(stepTimerRef.current);
                  }
                  // 设置新的定时器
                  stepTimerRef.current = setTimeout(() => {
                    if (
                      pages[step]?.options?.find((item) => item.text === value)
                        ?.next_page !== undefined
                    ) {
                      setStep(
                        pages[step]?.options?.find(
                          (item) => item.text === value
                        )?.next_page - 1
                      );
                    } else {
                      setStep(pages[step].next_page - 1);
                    }
                    stepTimerRef.current = null;
                  }, 300);
                }
              }}
            />
          </div>
        );
      case "图文单选":
        return (
          <div className={styles["step-3"]}>
            <div className={styles["step-3-title"]}>{pages[step].title}</div>
            <div className={styles["step-3-content"]}>
              {pages[step]?.options?.map((item, index) => {
                const existingItem = postForm.find(
                  (findItem) => findItem.page === pages[step].page
                );
                const isSelected = existingItem?.selected_option === item.text;
                return (
                  <div
                    className={`${styles["step-3-content-item"]} ${
                      isSelected ? styles["step-3-content-item--active"] : ""
                    }`}
                    key={`${pages[step].page}-${index}`}
                    onClick={() => {
                      if (existingItem) {
                        return;
                      }

                      setPostForm((prev) => [
                        ...prev,
                        {
                          page: pages[step].page,
                          title: pages[step].title,
                          selected_option: item.text,
                          level_range: item.level || [],
                        },
                      ]);
                      // 清除之前的定时器
                      if (stepTimerRef.current) {
                        clearTimeout(stepTimerRef.current);
                      }
                      // 设置新的定时器
                      stepTimerRef.current = setTimeout(() => {
                        if (item?.next_page !== undefined) {
                          setStep(item?.next_page - 1);
                        } else {
                          setStep(pages[step].next_page - 1);
                        }
                        stepTimerRef.current = null;
                      }, 300);
                    }}
                  >
                    <img className={styles["item-img"]} src={item.image} />
                    <div className={styles["item-text"]}>{item.text}</div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      case "文字单选":
        return (
          <div className={styles["step-4"]}>
            <div className={styles["step-4-title"]}>{pages[step].title}</div>
            <div className={styles["step-4-content"]}>
              {pages[step]?.options?.map((item, index) => {
                const existingItem = postForm.find(
                  (findItem) => findItem.page === pages[step].page
                );
                const isSelected = existingItem?.selected_option === item.text;
                return (
                  <div
                    className={`${styles["step-4-content-item"]} ${
                      isSelected ? styles["step-4-content-item--active"] : ""
                    }`}
                    key={`${pages[step].page}-${index}`}
                    onClick={() => {
                      if (existingItem) {
                        return;
                      }
                      setPostForm((prev) => [
                        ...prev,
                        {
                          page: pages[step].page,
                          title: pages[step].title,
                          selected_option: item.text,
                          level_range: item.level || [],
                        },
                      ]);
                      // 清除之前的定时器
                      if (stepTimerRef.current) {
                        clearTimeout(stepTimerRef.current);
                      }
                      // 设置新的定时器
                      stepTimerRef.current = setTimeout(() => {
                        if (item?.next_page !== undefined) {
                          setStep(item?.next_page - 1);
                        } else {
                          setStep(pages[step].next_page - 1);
                        }
                        stepTimerRef.current = null;
                      }, 300);
                    }}
                  >
                    <div className={styles["item-text"]}>{item.text}</div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const initData = async () => {
    try {
      toastRef.current = Toast.loading({
        message: "正在获取数据中...",
        forbidClick: true,
        duration: 0,
      });
      const res = await demoAnswerV2();
      if (res.code === 200 && Array.isArray(res.data)) {
        if (
          res.data[0].type === "开始页面" &&
          res.data[1].title === "请输入学员英文名"
        ) {
          setStep(1);
        }
        setPages(res.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      if (toastRef.current?.clear) {
        toastRef.current.clear();
        toastRef.current = null;
      }
    }
  };

  const handleSubmit = async () => {
    const submitRequest = showNav ? submitAnswerV3 : spokenSubmitAnswer;
    try {
      toastRef.current = Toast.loading({
        message: "正在提交数据中...",
        forbidClick: true,
        duration: 0,
      });
      const postData = {
        question_answers: postForm,
      };
      if (!showNav) {
        postData.token = wxTokenRef.current;
      }
      const res = await submitRequest(postData);
      if (res.code === 200) {
        if (params.get("isWx") === "true") {
          if (res.data.message) {
            Toast.info(res.data.message);
          } else {
            Toast.success("正在生成报告...");
            setTimeout(() => {
              wx.miniProgram.redirectTo({
                url: `/pages/test/teacherReport/index?id=${res.data.id}`,
              });
            }, 2000);
          }
          return;
        } else {
          Toast.success("提交成功，正在生成报告...");
          setTimeout(() => {
            navigate(`/testReport?id=${res.data.id}`, { replace: true });
          }, 2000);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      if (toastRef.current?.clear) {
        toastRef.current.clear();
        toastRef.current = null;
      }
    }
  };

  // 解密JWT token的函数
  const decryptToken = (encryptedData, secretKey = "wxintrotesttoken0") => {
    try {
      if (!encryptedData) {
        console.error("加密数据为空");
        return null;
      }

      // ✅ 先进行URL解码，处理可能被编码的+和/字符
      let decodedData = decodeURIComponent(encryptedData);

      // 使用默认的CBC模式解密
      const decrypted = CryptoJS.AES.decrypt(decodedData, secretKey);

      const result = decrypted.toString(CryptoJS.enc.Utf8);

      if (!result) {
        throw new Error("解密结果为空，可能密钥错误");
      }

      console.log("网页端解密成功:", result);
      return result;
    } catch (error) {
      console.error("网页端解密失败:", error);
      return null;
    }
  };

  useEffect(() => {
    if (params.get("isWx") === "true") {
      if (params.get("token")) {
        const decrypted = decryptToken(params.get("token"));
        wxTokenRef.current = decrypted;
      } else {
        Toast.fail("缺少参数请返回重试...");
      }
    } else {
      setShowNav(true);
    }
  }, []);

  useEffect(() => {
    initData();
    return () => {
      if (toastRef.current?.clear) {
        toastRef.current.clear();
        toastRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (step === pages.length - 1 && postForm.length > 0) {
      handleSubmit();
    }
  }, [step, postForm.length]);

  return (
    <div className={styles["intro-test-container"]}>
      {showNav && (
        <CommonNavBar
          backgroundColor={"transparent"}
          onClickBack={() => {
            navigate(-1);
          }}
        />
      )}
      <div className={styles["header"]}>
        <div className={styles["header-progress"]}>
          {step > 1 && (
            <div className={styles["header-progress-content"]}>
              <div
                className={styles["content-bar"]}
                style={{
                  width: `${parseFraction(pages[step].schedule) * 100}%`,
                }}
              ></div>
            </div>
          )}
        </div>
        <img
          className={styles["header-icon"]}
          src={require("@/images/picture/intro-test/title-phone.png")}
        />
      </div>
      {pages.length > 0 ? renderStep() : null}
      {step > 1 && postForm.length > 0 && step !== pages.length - 1 ? (
        <div className={styles["footer"]}>
          <div
            className={styles["footer-last-button"]}
            onClick={() => {
              //清除正在等待的跳转定时器
              if (stepTimerRef.current) {
                clearTimeout(stepTimerRef.current);
                stepTimerRef.current = null;
              }

              // 如果没有答案，不做任何处理
              if (postForm.length === 0) {
                return;
              }

              const lastAnswer = postForm[postForm.length - 1];
              const newPostForm = postForm.slice(0, -1);
              setPostForm(newPostForm);

              const targetIndex = pages.findIndex(
                (p) => p.page === lastAnswer.page
              );
              setStep(targetIndex !== -1 ? targetIndex : 1);
            }}
          >
            上一题
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default IntroTest;
